"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "mb-2 text-base leading-[1.2]" };
const _hoisted_2 = { class: "mb-4 text-2xl font-semibold leading-[1.2]" };
const store_1 = require("@/state/store");
const main_1 = require("@/main");
exports.default = (0, vue_1.defineComponent)({
    __name: 'HeadlineLandingPage',
    setup(__props) {
        if (store_1.store.landingPage.headerText === "") {
            store_1.store.landingPage.headerText = (0, main_1.$t)("landingPage.headline");
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("p", _hoisted_1, (0, vue_2.toDisplayString)((0, vue_2.unref)(main_1.$t)("landingPage.subheadline")), 1),
                (0, vue_2.createElementVNode)("h1", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(store_1.store).landingPage.headerText), 1)
            ], 64));
        };
    }
});
